import { render, staticRenderFns } from "./AdministrativeIndex.vue?vue&type=template&id=209bcbd8"
import script from "./AdministrativeIndex.vue?vue&type=script&lang=js"
export * from "./AdministrativeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports